<form [formGroup]="pipSelectionCoverage">
  <axis-card>
    <axis-card-body>
      <h1 class="axis-h3">Account Details</h1>
      <div class="axis-grid axis-form-row">
        <div class="axis-col-sm-6">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="insuredAuthName"
            >
              Insured Authorized Representative Name
            </label>
            <div class="axis-form-control-static">{{ pipSelectionCoverage.get("pipSelectInsuredName").value }}</div>
          </div>
        </div>

        <div class="axis-col-sm-6">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="insuredAuthTitle"
            >
              Insured Authorized Representative Title
            </label>
            <div class="axis-form-control-static">{{ pipSelectionCoverage.get("pipSelectInsuredAuthName").value }}</div>
          </div>
        </div>

        <div class="axis-col-sm-6">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="insuredPolicyName"
            >
              Company/Insured Name As On Policy
            </label>
            <div class="axis-form-control-static">{{ pipSelectionCoverage.get("pipSelectInsuredPolicy").value }}</div>
          </div>
        </div>

        <div class="axis-col-sm-6 axis-col-lg-3">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="businessMail"
            >
              Business Email Address
            </label>
            <div class="axis-form-control-static">{{ pipSelectionCoverage.get("pipSelectBusinessMail").value }}</div>
          </div>
        </div>

        <div class="axis-col-sm-6 axis-col-lg-3">
          <div
            class="axis-form-group"
            [ngClass]="{
              'has-axis-error':
                pipSelectionCoverage.get('pipSelectBusinessNum')?.invalid &&
                pipSelectionCoverage.get('pipSelectBusinessNum')?.touched,
            }"
          >
            <label
              class="axis-control-label"
              for="businessPhoneNum"
            >
              Business Phone Number
            </label>
            <input
              autocomplete="off"
              axis-input-clear
              type="text"
              class="axis-form-control"
              id="businessPhoneNum"
              formControlName="pipSelectBusinessNum"
            />
            <div
              class="axis-error-block"
              id="businessPhoneNum"
              *ngIf="
                pipSelectionCoverage.get('pipSelectBusinessNum')?.invalid &&
                pipSelectionCoverage.get('pipSelectBusinessNum')?.touched
              "
            >
              Please enter a valid Business Phone Number (10 digits).
            </div>
          </div>
        </div>

        <div class="axis-col-sm-6">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="streetAddress"
            >
              Business Street Address
            </label>
            <div class="axis-form-control-static">{{ pipSelectionCoverage.get("pipSelectBusinessAdd").value }}</div>
          </div>
        </div>

        <div class="axis-col-sm-6 axis-col-lg-3">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="businessCity"
            >
              Business City
            </label>
            <div class="axis-form-control-static">{{ pipSelectionCoverage.get("pipSelectBusinessCity").value }}</div>
          </div>
        </div>

        <div class="axis-col-sm-6 axis-col-lg-3">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="businessState"
            >
              Business State
            </label>
            <div class="axis-form-control-static">{{ pipSelectionCoverage.get("pipSelectBusinessState").value }}</div>
          </div>
        </div>
      </div>
    </axis-card-body>
  </axis-card>
  <!-- Garaging Section -->
  @if (shouldShowGarageStates) {
  <axis-card>
    <axis-card-body>
      <h2 class="axis-h3">{{ garageStatesData?.title }}</h2>
      <div
        class="axis-form-group control-auto-height has-axis-required"
        [ngClass]="{
          'has-axis-error':
            pipSelectionCoverage.get('garagingSelection')?.invalid &&
            pipSelectionCoverage.get('garagingSelection')?.touched,
        }"
        [ngClass]="{
          'has-axis-required':
            pipSelectionCoverage.get('garagingSelection')?.value?.value === '' ||
            pipSelectionCoverage.get('garagingSelection')?.value?.value === undefined ||
            pipSelectionCoverage.get('garagingSelection')?.value?.value === null,
        }"
      >
        <axis-radio-button-wrapper formControlName="garagingSelection">
          @for (option of garageStatesData?.garagingOptions; track option) {
            <axis-media class="align-top">
              <axis-media-left>
                <axis-radio
                  [checked]="checkPreselect(option)"
                  heading="{{ option.label }}"
                  name="garaging"
                  value="{{ option.value }}"
                  class="inline"
                  (changeDetect)="patchValue('garagingSelection', option.value)"
                >
                </axis-radio>
              </axis-media-left>
            </axis-media>
          }
        </axis-radio-button-wrapper>
        <div
          class="axis-error-block"
          *ngIf="
            pipSelectionCoverage.get('garagingSelection')?.invalid &&
            pipSelectionCoverage.get('garagingSelection')?.touched
          "
        >
          Please select a garaging option.
        </div>
      </div>
    </axis-card-body>
  </axis-card>
}
  <!-- PIP Section -->
  <axis-card>
    <axis-card-body>
      <h2 class="axis-h3">{{ data?.title }}</h2>
      <p class="_text-medium">
        PIP coverage is not available in all states. Coverage Selection forms will be generated only in the states where
        PIP Coverage is available.
      </p>

      <!-- Primary selection -->
      <div
        class="axis-form-group has-axis-required"
        [ngClass]="{
          'has-axis-error':
            pipSelectionCoverage.get('pipBodilyInjuryVar').invalid &&
            pipSelectionCoverage.get('pipBodilyInjuryVar').touched,
          'has-axis-required':
            pipSelectionCoverage.get('pipBodilyInjuryVar')?.value?.value === '' ||
            pipSelectionCoverage.get('pipBodilyInjuryVar')?.value?.value === null ||
            pipSelectionCoverage.get('pipBodilyInjuryVar')?.value?.value === undefined,
        }"
      >
        <label class="axis-control-label">
          Please make your coverage selections.
          <span
            aria-hidden="true"
            class="axis-required-indicator"
            >*</span
          >
        </label>
        <axis-radio-button-wrapper formControlName="pipBodilyInjuryVar">
          @for (option of data?.selectionOptions; track option) {
            <axis-media>
              <axis-media-left>
                <axis-radio
                  [checked]="checkPreselect(option)"
                  heading="{{ option.label }}"
                  name="selectedOption"
                  value="{{ option.value }}"
                  (changeDetect)="patchValue('pipBodilyInjuryVar', option.value)"
                >
                </axis-radio>
              </axis-media-left>
              <axis-media-body>
                <app-tooltip-label
                  content="{{ option.tooltip }}"
                  width="400px"
                  ariaLabel="Info"
                ></app-tooltip-label>
              </axis-media-body>
            </axis-media>
          }
        </axis-radio-button-wrapper>
        <div
          class="axis-error-block"
          *ngIf="
            pipSelectionCoverage.get('pipBodilyInjuryVar').invalid &&
            pipSelectionCoverage.get('pipBodilyInjuryVar').touched
          "
        >
          Please select an option.
        </div>
      </div>
 @if (shouldShowOtherOptions) {
      <!-- Additional PIP -->
      <div
        class="axis-form-group control-auto-height has-axis-required"
        [ngClass]="{
          'has-axis-error':
            pipSelectionCoverage.get('pipAdditionalOptions')?.invalid &&
            pipSelectionCoverage.get('pipAdditionalOptions')?.touched,
          'has-axis-required':
            pipSelectionCoverage.get('pipAdditionalOptions')?.value?.value === '' ||
            pipSelectionCoverage.get('pipAdditionalOptions')?.value?.value === null ||
            pipSelectionCoverage.get('pipAdditionalOptions')?.value?.value === undefined,
        }"
      >
        <label class="axis-control-label">
          Additional PIP Coverage where offered
          <span
            aria-hidden="true"
            class="axis-required-indicator"
            >*</span
          >
          <app-tooltip-label
            content="<b>Additional PIP</b> <div><p>Additional PIP Coverage allows for the selection of PIP Limits above minimum required limits or minimum limits offered. To the extent that certain coverage(s) or benefit(s) are required in a particular state, it will automatically be included in your policy.</p>"
            width="400px"
            ariaLabel="Info"
          ></app-tooltip-label>
        </label>
        <axis-radio-button-wrapper formControlName="pipAdditionalOptions">
          @for (option of data?.additionalOptions; track option) {
            <axis-radio
              [checked]="checkPreselect(option)"
              heading="{{ option.label }}"
              name="additionalOptions"
              value="{{ option.value }}"
              class="inline"
              (changeDetect)="patchValue('pipAdditionalOptions', option.value)"
            ></axis-radio>
          }
        </axis-radio-button-wrapper>
        <div
          class="axis-error-block"
          *ngIf="
            pipSelectionCoverage.get('pipAdditionalOptions').invalid &&
            pipSelectionCoverage.get('pipAdditionalOptions').touched
          "
        >
          Please select an option.
        </div>
      </div>
    }
      <!-- Groups -->
      @if (shouldShowCard) {
        <axis-card class="size-small">
          <axis-card-body>
            @for (group of data?.groups; track group) {
              <div
                class="axis-form-group control-auto-height has-axis-required"
                [ngClass]="{
                  'has-axis-error':
                    pipSelectionCoverage.get(group.name)?.invalid && pipSelectionCoverage.get(group.name)?.touched,
                  'has-axis-required':
                    pipSelectionCoverage.get(group.name)?.value?.value === '' ||
                    pipSelectionCoverage.get(group.name)?.value?.value === null ||
                    pipSelectionCoverage.get(group.name)?.value?.value === undefined,
                }"
              >
                <label class="axis-control-label">
                  {{ group.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>

                <axis-radio-button-wrapper [formControlName]="group.name">
                  @for (option of group.options; track option) {
                    <axis-radio
                      heading="{{ option.label }}"
                      name="{{ group.name }}"
                      value="{{ option.value }}"
                      class="inline"
                      (changeDetect)="patchValue(group.name, option.value)"
                    ></axis-radio>
                  }
                </axis-radio-button-wrapper>

                <div
                  class="axis-error-block"
                  *ngIf="pipSelectionCoverage.get(group.name)?.invalid && pipSelectionCoverage.get(group.name)?.touched"
                >
                  Please select an option for {{ group.label }}.
                </div>
              </div>
            }
          </axis-card-body>
        </axis-card>
      }

    </axis-card-body>
  </axis-card>

  <div class="axis-btn-wrapper">
    @if (!this.baseRulesService.isPlayground) {
    <div class="axis-btn-wrapper-left">
      <button
        axis-button
        class="kind-secondary"
        (click)="onBack()"
      >
        <span class="axis-btn-icon-text">Back</span>
      </button>
    </div>
    }
    <div class="axis-btn-wrapper-right">
      <button
        axis-button
        class="kind-primary"
        (click)="onContinue()"
      >
        <span class="axis-btn-icon-text">Continue</span>
      </button>
    </div>
  </div>
</form>
